import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { AssetsFormValues } from 'src/models/Assets.model';
import AssetsForm from '../Layouts/AssetsForm';
import { useAddAssetsMutation } from 'src/services/AssetsServices';
import { showToast } from 'src/utils/showToaster';

type Props = {
  onClose: () => void;
};

const AddAssetsFormWrapper = ({ onClose }: Props) => { 
    const [addAssets] = useAddAssetsMutation()
  // Form Initial Values
  const initialValues: AssetsFormValues = {
   assetName :'',
   bill :'',
  };

  // Validation Schema
  const validationSchema = object().shape({
    assetName: string().required('Please enter name'),
  });

  // Handle Submit
  const handleSubmit = (
    values: AssetsFormValues,
    { setSubmitting, resetForm }: FormikHelpers<AssetsFormValues>
  ) => {
    addAssets(values).then((res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
              resetForm();
              onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      });
  };

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <AssetsForm formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddAssetsFormWrapper;